import React from 'react';
import { ArrowRightIcon, BuildingIcon, DollarSignIcon, UserIcon, MapPinIcon, WrenchIcon, BriefcaseIcon, CpuIcon, ScaleIcon, StarIcon } from 'lucide-react';
const industries = [{
  name: 'Accounting & Finance',
  count: '1.2M+',
  icon: DollarSignIcon,
  href: '#/data/accounting',
  description: 'CPAs, tax preparers, and bookkeepers'
}, {
  name: 'Healthcare & Medical',
  count: '2.5M+',
  icon: UserIcon,
  href: '#/data/doctors',
  description: 'Doctors, dentists, and clinics'
}, {
  name: 'Food & Beverage',
  count: '3.8M+',
  icon: StarIcon,
  href: '#/data/restaurants',
  description: 'Restaurants, cafes, and bars'
}, {
  name: 'Home Services',
  count: '4.1M+',
  icon: WrenchIcon,
  href: '#/data/plumbing',
  description: 'Plumbers, HVAC, and electricians'
}, {
  name: 'Real Estate',
  count: '1.8M+',
  icon: BuildingIcon,
  href: '#/data/property-management',
  description: 'Property managers and brokers'
}, {
  name: 'Automotive',
  count: '1.5M+',
  icon: CpuIcon,
  href: '#/data/car-dealer',
  description: 'Dealerships and repair shops'
}, {
  name: 'Legal Services',
  count: '800K+',
  icon: ScaleIcon,
  href: '#/data/lawyers',
  description: 'Law firms and attorneys'
}, {
  name: 'Beauty & Wellness',
  count: '2.2M+',
  icon: BriefcaseIcon,
  href: '#/data/salons',
  description: 'Salons, spas, and gyms'
}];
export function DatabaseIndustryGrid() {
  return <section className="py-24 bg-slate-50 border-t border-slate-100" data-id="element-4001">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4002">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4003">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-4004">
            Browse local business listings by{' '}
            <span className="text-blue-600" data-id="element-4005">industry</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-4006">
            Find the exact local small businesses you need. Our local business
            database covers 300+ categories with verified business owner emails.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-4007">
          {industries.map(industry => <a key={industry.name} href={industry.href} className="group bg-white border border-slate-200 rounded-2xl p-6 hover:border-blue-500 hover:shadow-lg transition-all duration-200 flex flex-col h-full" data-id="element-4008">
              <div className="flex items-start justify-between mb-4" data-id="element-4009">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors" data-id="element-4010">
                  <industry.icon className="w-6 h-6" data-id="element-4011" />
                </div>
                <div className="text-xs font-bold text-slate-500 bg-slate-100 px-2.5 py-1 rounded-full" data-id="element-4012">
                  {industry.count}
                </div>
              </div>

              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-4013">
                {industry.name}
              </h3>
              <p className="text-sm text-slate-500 mb-6 flex-grow" data-id="element-4014">
                {industry.description}
              </p>

              <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-600 group-hover:gap-2.5 transition-all mt-auto" data-id="element-4015">
                Explore database
                <ArrowRightIcon className="w-4 h-4" data-id="element-4016" />
              </div>
            </a>)}
        </div>

        <div className="mt-12 text-center" data-id="element-4017">
          <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-slate-200 text-slate-700 font-bold rounded-full hover:border-slate-300 hover:bg-slate-50 transition-colors" data-id="element-4018">
            <BriefcaseIcon className="w-5 h-5" data-id="element-4019" />
            Search all 300+ business categories
          </a>
        </div>
      </div>
    </section>;
}